import { render, staticRenderFns } from "./IntraoralEditNumberDialog.vue?vue&type=template&id=80d59cd6&scoped=true&"
import script from "./IntraoralEditNumberDialog.vue?vue&type=script&lang=js&"
export * from "./IntraoralEditNumberDialog.vue?vue&type=script&lang=js&"
import style0 from "./IntraoralEditNumberDialog.vue?vue&type=style&index=0&id=80d59cd6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80d59cd6",
  null
  
)

export default component.exports